const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Tack för att du registrerat dig hos BRIDGESTONE PLUS",
      content:
        "Kära,<br/>Tack för att du har registrerat dig. Vi är glada att kunna informera dig om att din registrering på BRIDGESTONE PLUS har granskats och godkänts.<br/>Vi hoppas att BRIDGESTONE PLUS ger dig framgång och värdefulla möjligheter, och vi ser fram emot ett fortsatt samarbete.<br/>Bästa hälsningar,<br/>BRIDGESTONE PLUS-teamet",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Tack för att du registrerat dig hos BRIDGESTONE PLUS",
      content:
        "Kära,<br/>Tack för att du har registrerat dig. Vi är glada att kunna informera dig om att din registrering på BRIDGESTONE PLUS har granskats och godkänts.<br/>Vi hoppas att BRIDGESTONE PLUS ger dig framgång och värdefulla möjligheter, och vi ser fram emot ett fortsatt samarbete.<br/>Bästa hälsningar,<br/>BRIDGESTONE PLUS-teamet",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
